import { Provider } from "react-redux";
import BlogPage from "./components/BlogPage";
import Footer from "./components/Footer";
import Navigation from "./components/Navigation";
import SearchBar from "./components/SearchBar";
import store from "./redux/store";

function App() {
  return (
    <Provider store={store}>
      <Navigation />
      <SearchBar />
      <BlogPage />
      <Footer />
    </Provider>
  );
}

export default App;
